import { injectable } from 'inversify';

import { Collection, EventTypesList } from '@app/gen/event-type';

import { COLLECTIONS_ICONS } from '../constants';

@injectable()
export class ProcessCatalogMapper {
  processCatalogCollections(collections: Collection[]) {
    return collections.map(({ type, ...collection }) => ({
      ...collection,
      icon: COLLECTIONS_ICONS[type],
    }));
  }
  processEventTypes(eventTypes: EventTypesList[]) {
    return eventTypes.map(
      ({ company_ids, event_type_ids, start_side, ...eventType }) => ({
        id: `${event_type_ids.join('-')}-${start_side.join('-')}`,
        companyIds: company_ids,
        eventTypeIds: event_type_ids,
        startSide: start_side,
        hasCompanySide:
          start_side.includes('group') || start_side.includes('manager'),
        ...eventType,
      }),
    );
  }
}
